export const fetchCart = () => fetch("/cart.json");

export const addVariantsToCart = (items) =>
  fetch("/cart/add.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items,
    }),
  });

export const updateVariantQuantity = (variantId, quantity = 1) =>
  fetch("/cart/change.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: `${variantId}`,
      quantity,
    }),
  });

export const updateCartNote = (note) =>
  fetch("/cart/update.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ note }),
  });

export const updateCartAttributes = (attributes = {}, note = null) => {
  const body = { attributes };
  if (note !== null) {
    body.note = note;
  }

  return fetch("/cart/update.js", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
};
